import { styled } from "@mui/material";
import { StoreBadgeImage } from "../store-badge-styles";

export const StyledAppStore = styled(StoreBadgeImage)``;
